export const DSDE_REFERENCE_OVERVIEW_FIELDS = [
  {
    label: "Reference Source",
    value: "name",
  },
  {
    label: "Reference Type",
    value: "reference_source_type",
  },
  {
    label: "# of CDEs Mapped",
    value: "cde_mapped_count",
  },
  {
    label: "# of DSDE Mapped",
    value: "dsde_mapped_count",
  },
  {
    label: "Sourced through",
    value: "source_type",
  },
];
